import script from "./BusinessHours.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessHours.vue?vue&type=script&setup=true&lang=js"

import "./BusinessHours.vue?vue&type=style&index=0&id=a5af221a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5af221a"]])

export default __exports__